import {Organization} from "@App/types";
import {Organizations} from "@App/types/enums";
import {TFunction} from "react-i18next";

const orgString = (organization: Organization) => organization.id === Organizations.LEASEPLAN ? 'leaseplan' : 'repareo'
export const phoneLink = (organization: Organization, t: TFunction) => t('contact.phone-link-' + orgString(organization))
export const phone = (organization: Organization, t: TFunction) => t('contact.phone-' + orgString(organization))
